import React from "react";
import useNumberToWords from "utils/hooks/useNumberToWord";
import "./ReceiptFormate.css";

const ReceiptFormate = (props) => {
	const { getTableData } = props;
	const { numberToWords } = useNumberToWords();
	const receiptData = {
		customerName: `${getTableData.name}`,
		// amountPaid: `${getTableData.txn_amount}`,
		amountPaid: `${getTableData?.premium_amount}`,
		customerId: getTableData.customer_id,
		transactionDate: getTableData.policy_date,
		email: `${getTableData.email}`,
		mobileNumber: `${getTableData.mobile}`,
		contact: `${getTableData.mobile}`,
	};

	const amount = parseInt(receiptData.amountPaid, 10);
	const gstPercentage = 18;
	const baseAmount = Math.round((amount * 100) / (100 + gstPercentage));
	const gstAmount = amount - baseAmount;

	return (
		<div className="receipt-formate-container">
			<div className="receipt-formate-header">
				<div>
					<img
						src={`${window.location.origin}/grameseva-logo-new.webp`}
						alt="Logo"
						className="receipt-formate-logo"
					/>
				</div>
				<div className="receipt-formate-company-info">
					<p>
						OFFICE NO 504, 5TH FLOOR, ZION TOWER, SECTOR 10,<br/> KHARGHAR, NAVI MUMBAI, 410210
					</p>
					<p>GST: 27AACCO166R1ZT, Email ID: info@gramepay.com</p>
				</div>
			</div>

			<div className="receipt-formate-invoice-title">GST Invoice</div>

			<div className="receipt-formate-billing-info">
				<div>
					<p>
						<strong>Billing to:</strong> {receiptData.customerName}
					</p>
				</div>
				<div>
					<p>
						<strong>Customer ID:</strong> {receiptData.customerId}
					</p>
					<p>
						<strong>Invoice Date:</strong> {receiptData.transactionDate}
					</p>
				</div>
			</div>

			<table className="receipt-formate-table">
				<thead>
					<tr style={{ backgroundColor: "#f2f2f2" }}>
						<th className="receipt-formate-table-header">Sr. No.</th>
						<th className="receipt-formate-table-header">Particulars</th>
						<th className="receipt-formate-table-header">Rate</th>
						<th className="receipt-formate-table-header">Amount</th>
						<th className="receipt-formate-table-header">SGST</th>
						<th className="receipt-formate-table-header">CGST</th>
						<th className="receipt-formate-table-header">Total</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="receipt-formate-table-cell">1</td>
						<td className="receipt-formate-table-cell">
							{getTableData.package_name || "N/A"}
						</td>
						{/* <td className="receipt-formate-table-cell">₹{baseAmount}</td>
						<td className="receipt-formate-table-cell">₹{baseAmount}</td> */}
						<td className="receipt-formate-table-cell">₹{getTableData?.gross_premium}</td>
						<td className="receipt-formate-table-cell">₹{getTableData?.gross_premium}</td>
						<td className="receipt-formate-table-cell">9%</td>
						<td className="receipt-formate-table-cell">9%</td>
						<td className="receipt-formate-table-cell">₹{getTableData?.premium_amount}</td>
					</tr>
				</tbody>
			</table>

			<div className="receipt-formate-total-info">
				<p>
					<strong>Rupees in Words: </strong>
					{numberToWords(parseInt(amount, 10))}
				</p>
				<p>
					<strong>Total GST Chargeable:</strong> ₹{getTableData?.gst}, GST:{" "}
					{gstPercentage}%
				</p>
			</div>

			<div className="receipt-formate-footer">
				GRAM DIGITAL INNOVATION SERVICES PRIVATE LIMITED
			</div>
			<div className="receipt-formate-signatory">
				<p>Authorised Signatory</p>
				<p className="receipt-formate-italic-note">
					*This is a Computer Generated Invoice
				</p>
			</div>

			{/* <div className="receipt-formate-print-button-container">
				<button
					className="receipt-formate-print-button"
					onClick={() => window.print()}
				>
					Print Receipt
				</button>
			</div> */}
		</div>
	);
};

export default ReceiptFormate;
